import { render, staticRenderFns } from "./ReportTemplatesList.vue?vue&type=template&id=7e640ceb&"
import script from "./ReportTemplatesList.vue?vue&type=script&lang=ts&"
export * from "./ReportTemplatesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports